var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coll_main" }, [
    _c(
      "div",
      { staticClass: "coll_main mt8", class: _vm.fold ? "mess_mb8" : "" },
      [
        _c("div", { staticClass: "flex_colum coll_box" }, [
          _c(
            "div",
            {
              staticClass: "show_box flex_center flex_auto",
              on: { click: _vm.handleFold },
            },
            [
              _c("span", { staticClass: "show_title" }, [
                _vm._v(_vm._s(_vm.localTitle)),
              ]),
              _c("svg-icon", {
                staticClass: "show_img",
                class: { rote: !_vm.fold },
                attrs: { "icon-class": "arrow_bottom" },
              }),
            ],
            1
          ),
          _c("div", { class: { dot_box: _vm.dot && !_vm.fold } }),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.fold,
            expression: "!fold",
          },
        ],
        staticClass: "mt8",
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }